import React from 'react';
import './RecentBlogs.css';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaRegCalendarAlt } from 'react-icons/fa';

const InternationalNews = ({ data }) => {
  const navigate = useNavigate();

  const getColorClass = (name) => {
    const key = name?.toLowerCase().replace(/\s/g, '');
    const colors = {
      recipes: 'tag-red',
      fastfood: 'tag-orange',
      vegetables: 'tag-purple',
      tips: 'tag-green',
    };
    return colors[key] || 'tag-default';
  };

  if (!data || data.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p className="loader-text">Loading recent blogs...</p>
      </div>
    );
  }

  const leftCards = data.slice(0, 4);
  const rightCards = data.slice(4, 9);

  return (
    <section className="international-news-wrapper">
      <h2 className="section-title">Recent Blogs</h2>
      <div className="news-container">
        <div className="left-section">
          {leftCards.map((item) => (
            <div
              key={item.id}
              className="news-card-large"
              onClick={() => navigate(`/blog/${item.slug}`)}
            >
              <div className="image-wrapper">
                <img
                  src={`https://api.funfillia.com/${item.image_400x300}`}
                  alt={item.title}
                  title={item.title}
                />
                <span className={`tag ${getColorClass(item.category?.name)}`}>
                  {item.category?.name || 'Blog'}
                </span>
              </div>
              <h3 className="title">{item.title}</h3>
              <p className="meta">
                <FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp;&nbsp;
                <FaEye/> {item.views_count} views
              </p>
            </div>
          ))}
        </div>

        <div className="right-section">
          <div className="tabs">
            <button className="tab active">Recent Blogs</button>
          </div>

          <div className="trending-list">
            {rightCards.map((item) => (
              <div
                key={item.id}
                className="trending-card"
                onClick={() => navigate(`/blog/${item.slug}`)}
              >
                <img
                  src={`https://api.funfillia.com/${item.image_200x200}`}
                  alt={item.title}
                  title={item.title}
                />
                <div className="text-group">
                  <p className="title">{item.title}</p>
                  <p className="meta">
                    <FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp;&nbsp;
                    <FaEye/> {item.views_count} views
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternationalNews;
